import type { MenuButtonProps, PlacementWithLogical } from "@chakra-ui/react";
import { Link } from "@src/components/ui-kit";
import useIntersectionObserver from "@src/utils/hooks/useIntersectionObserver";
import { observer, useLocalObservable } from "mobx-react-lite";
import type { Route } from "nextjs-routes";
import { type PropsWithChildren, useRef } from "react";
import { CreateProjectMenuStore } from "./store";

type Props = {
  menuPlacement?: PlacementWithLogical;
  listPlacement?: PlacementWithLogical;
  menuButtonProps?: MenuButtonProps;
  onItemSelect?: () => void;
  /**
   * @param queryParams adds query params to link except for From template redirect
   */
  queryParams?: Route["query"];
};
export const CreateProjectMenu = observer(function CreateProjectMenu({
  children,
  // menuPlacement,
  // listPlacement = "right-start",
  // menuButtonProps,
  // onItemSelect,
  queryParams,
}: PropsWithChildren<Props>) {
  const { store } = useLocalObservable(() => ({
    store: new CreateProjectMenuStore(),
  }));
  const spinnerRootRef = useRef<HTMLDivElement>(null);
  const spinnerWrapperRef = useRef<HTMLDivElement>(null);

  useIntersectionObserver({
    root: spinnerRootRef.current,
    target: spinnerWrapperRef,
    threshold: 0.01,
    onIntersect: () => {
      if (store.fetcher.isLoading.value) return;
      if (!store.pagination.canLoadMore) return;

      store.fetchData(store.pagination.asParams);
    },
  });

  return (
    <Link
      href={{ pathname: "/projects/create", query: queryParams }}
      color="black"
    >
      {children}
    </Link>
  );

  // return (
  //   <Menu
  //     isLazy
  //     onOpen={() => {
  //       store.pagination.resetPage();
  //     }}
  //     placement={menuPlacement}
  //   >
  //     <MenuButton {...menuButtonProps}>{children}</MenuButton>
  //     <MenuList>
  //       <MenuItemLink
  //         href={{ pathname: "/projects/create", query: queryParams }}
  //         onClick={onItemSelect}
  //       >
  //         <Trans>Blank</Trans>
  //       </MenuItemLink>
  //       <MenuItemLink
  //         href={{
  //           pathname: "/projects/create",
  //           query: {
  //             ...queryParams,
  //             isTemplate: "true",
  //           },
  //         }}
  //         onClick={onItemSelect}
  //       >
  //         <Trans>Template</Trans>
  //       </MenuItemLink>
  //       <MenuItem as={Menu} placement={listPlacement}>
  //         <MenuButton
  //           w="full"
  //           px="3"
  //           py="1.5"
  //           textAlign="left"
  //           _hover={{ bgColor: "gray.100" }}
  //         >
  //           <Trans>From template</Trans>
  //         </MenuButton>
  //         <Portal appendToParentPortal>
  //           <MenuList overflowY="auto" maxW="280px" maxH="300px">
  //             {store.projectTemplates.map((template) => (
  //               <MenuItemLink
  //                 key={`project-template-${template.id}`}
  //                 href={{
  //                   pathname: "/projects/create",
  //                   query: {
  //                     fromTemplateId: template.id,
  //                   },
  //                 }}
  //                 onClick={onItemSelect}
  //               >
  //                 <Tooltip
  //                   label={`${template.code} - ${template.title}`}
  //                   openDelay={200}
  //                   placement="top"
  //                 >
  //                   <Text overflow="elipsis" isTruncated>
  //                     {template.code}&nbsp;-&nbsp;{template.title}
  //                   </Text>
  //                 </Tooltip>
  //               </MenuItemLink>
  //             ))}
  //             {!store.fetcher.isLoading.value &&
  //               !store.projectTemplates.length && (
  //                 <Center minH="8">
  //                   <Trans>No templates found</Trans>
  //                 </Center>
  //               )}
  //             {store.projectTemplates.length !== store.pagination.total && (
  //               <Box>
  //                 <Center ref={spinnerWrapperRef}>
  //                   <Spinner />
  //                 </Center>
  //               </Box>
  //             )}
  //           </MenuList>
  //         </Portal>
  //       </MenuItem>
  //     </MenuList>
  //   </Menu>
  // );
});
